import React from 'react';
import WaterCoolerCreateComment from './WaterCoolerCreateComment';


export default () => {

  return (
    <div className="wc-write-comment">
      <WaterCoolerCreateComment />
    </div>
  );
}